import { useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { API_CACHE_KEYS, API_PATHS } from '@/modules/common/constants';
import { _generateUTMQuery } from '@/utils/helper';
import { ApiClient } from '@pw-tech/web-sdk';
import { useToast } from '@pw-tech/omni-ui';

/**
 * Hook for capturing leads
 */
export const useLeadCapture = () => {
  // Create the mutation
  const { toast: showToaster } = useToast();
  const { isPending, error, mutate, mutateAsync } = useMutation(
    [API_CACHE_KEYS.LEAD_CAPTURE],
    () => {
      // Generate UTM query string for tracking
      const utmQuery = _generateUTMQuery();
      return ApiClient.post(`${API_PATHS.LEAD_CAPTURE}${utmQuery}`, {});
    }
  );

  useEffect(() => {
    if (error) {
      showToaster({
        message:
          typeof (error as any)?.message === 'string'
            ? (error as any).message
            : 'Error in Lead Capture',
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
      });
    }
  }, [error]);

  return {
    error,
    isPending,
    mutate,
    mutateAsync,
  };
};
